import { PageLayout } from '@plm-core/utils'
import { Breadcrumbs, Layout } from '@design-systems/canvas-ui'
import TeamsCreate from 'teams/components/create/TeamsCreate'
import { useNavigate } from 'react-router-dom'

const TeamsCreatePage = () => {
  const navigate = useNavigate()
  return (
    <>
      <Layout.PageHeader>
        <PageLayout>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate('/teams')}>
              Teams
            </Breadcrumbs.Item>
            <Breadcrumbs.Item>Create a team</Breadcrumbs.Item>
          </Breadcrumbs>
        </PageLayout>
      </Layout.PageHeader>
      <PageLayout withPageHeader>
        <TeamsCreate />
      </PageLayout>
    </>
  )
}

export default TeamsCreatePage
